module.exports = __webpack_public_path__ + "img/logo.9d8e363b.png";